import { render, staticRenderFns } from "./view.vue?vue&type=template&id=774df7a1"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774df7a1')) {
      api.createRecord('774df7a1', component.options)
    } else {
      api.reload('774df7a1', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=774df7a1", function () {
      api.rerender('774df7a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/spu/ordinary/view.vue"
export default component.exports